import { render, staticRenderFns } from "./addDiscount.vue?vue&type=template&id=0aabe95e&scoped=true&"
import script from "./addDiscount.vue?vue&type=script&lang=js&"
export * from "./addDiscount.vue?vue&type=script&lang=js&"
import style0 from "./addDiscount.vue?vue&type=style&index=0&id=0aabe95e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aabe95e",
  null
  
)

component.options.__file = "addDiscount.vue"
export default component.exports